import { STATUS_VARIANT_HIGHLIGHT } from '@/components/StatusWrapper/const';
import { InvoiceLinkExpiryType } from '@/types/invoiceVaultTypes';

export const INVOICE_VAULT_TABS = [
  { value: 'check', label: 'Check Invoice', disabled: false },
  { value: 'link', label: 'Link and QR code', disabled: false },
  { value: 'integrations', label: 'Integrations (Coming soon)', disabled: true },
  { value: 'api', label: 'Open API (Coming soon)', disabled: true },
] as const;

export type InvoiceVaultTabType = (typeof INVOICE_VAULT_TABS)[number]['value'];

export const INVOICE_LINK_EXPIRY_OPTIONS: { value: InvoiceLinkExpiryType; label: string }[] = [
  { value: '15d', label: '15 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
];

export const CHECK_EXPIRY_OPTIONS = [
  { value: '24h', label: '24 hours' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
] as const;

export const CHECK_TYPE_CARDS = [
  { value: 'ach', label: 'ACH', description: 'US bank account. Routing and account number.' },
  { value: 'wire', label: 'Domestic wire', description: 'US wire. Wire routing, account number and address.' },
  { value: 'intl', label: 'International', description: 'SWIFT/BIC, IBAN or account, bank address.' },
] as const;

export const CHECK_MODE_CARDS = [
  { value: 'request', label: 'Request', description: 'The vendor confirms the invoice and enters payout details.' },
  {
    value: 'verify',
    label: 'Verify and request',
    description: 'The vendor verifies their identity with TrustStamp first.',
  },
] as const;

export const LINK_MODE_CARDS = [
  {
    value: 'share',
    label: 'Share',
    description: 'Anyone with the link sees the instructions after confirming the invoice number.',
  },
  {
    value: 'verify',
    label: 'Verify and share',
    description: 'The payer verifies their identity before the instructions appear.',
  },
] as const;

export const INVOICE_LINK_STATUS_MAP = {
  active: STATUS_VARIANT_HIGHLIGHT.GREEN,
  viewed: STATUS_VARIANT_HIGHLIGHT.GREY,
  pending_verification: STATUS_VARIANT_HIGHLIGHT.YELLOW,
  completed: STATUS_VARIANT_HIGHLIGHT.GREEN,
  paid: STATUS_VARIANT_HIGHLIGHT.GREEN,
  disputed: STATUS_VARIANT_HIGHLIGHT.RED,
  expired: STATUS_VARIANT_HIGHLIGHT.GREY,
  revoked: STATUS_VARIANT_HIGHLIGHT.ROSE,
  cancelled: STATUS_VARIANT_HIGHLIGHT.GREY,
};

export const INVOICE_CHECK_STATUS_MAP = {
  active: STATUS_VARIANT_HIGHLIGHT.GREEN,
  viewed: STATUS_VARIANT_HIGHLIGHT.GREY,
  pending_verification: STATUS_VARIANT_HIGHLIGHT.YELLOW,
  completed: STATUS_VARIANT_HIGHLIGHT.GREEN,
  mismatch: STATUS_VARIANT_HIGHLIGHT.RED,
  declined: STATUS_VARIANT_HIGHLIGHT.RED,
  expired: STATUS_VARIANT_HIGHLIGHT.GREY,
  revoked: STATUS_VARIANT_HIGHLIGHT.ROSE,
};

export const DISPUTE_REASON_OPTIONS = [
  { value: 'info', label: 'Something on the invoice is wrong' },
  { value: 'amount', label: 'Dispute the amount' },
  { value: 'other', label: 'Other' },
] as const;

export const INVOICE_FILE_ACCEPT = '.pdf,.png,.jpg,.jpeg';
export const INVOICE_FILE_MAX_BYTES = 10 * 1024 * 1024;
